import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CreateUpdateDocumentsEntity } from '../../domain/entities/CreateUpdateDocumentsEntity'

export class CreateUpdateDocumentsModel extends CreateUpdateDocumentsEntity {
  constructor(dataDto: CreateUpdateDocumentsEntity) {
    super()
    mapEntityProperties<CreateUpdateDocumentsModel>(this, dataDto, {
      exclude: ['id', 'filePath', 'file']
    })
  }
}
